import { useWalletDetails } from "@sundae/wallet-react";
import { SundaeSDK } from "@sundaeswap/core";
import { ProviderSundaeSwap, TxBuilderLucid } from "@sundaeswap/core/extensions";
import {
  Context,
  FC,
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useReducer,
} from "react";
import { Actions } from "./actions";

import { getEnv } from "../../utils/network.utils";
import { appReducer } from "./reducer";
import { IAppAction, IAppContext, IAppState } from "./types";

export const defaultAppState: IAppState = {
  sdk: null,
  chooseHandleOpen: false,
  chooseAvatarOpen: false,
  offCanvasOpen: false,
  sortPoolsSortingDirection: undefined,
  sortPoolsBy: undefined,
  walletConnectOpen: false,
  wrongNetworkOpen: false,
  latestTxHash: undefined,
};

const AppContext: Context<IAppContext> = createContext({
  state: defaultAppState,
  dispatch: (_value: IAppAction) => {},
});

export const AppContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [state, dispatch] = useReducer(appReducer, defaultAppState);
  const { activeWallet } = useWalletDetails();

  useEffect(() => {
    (async () => {
      const network = getEnv();

      if (activeWallet) {
        const txBuilder = new TxBuilderLucid(
          {
            providerType: "blockfrost",
            blockfrost: {
              url: window.__APP_CONFIG.blockfrostUrl,
              apiKey: window.__APP_CONFIG.blockfrostKey,
            },
            network,
            wallet: activeWallet,
          },
          new ProviderSundaeSwap(network)
        );
        const sdk = new SundaeSDK(txBuilder);
        Actions.setSDK(sdk, dispatch);
      }
    })();
  }, [activeWallet]);

  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};

// Utility hook.
export const useAppContext = (): IAppContext => useContext(AppContext);
